var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortalDirective } from '@angular/material';
var TdDataTableTemplateDirective = (function (_super) {
    __extends(TdDataTableTemplateDirective, _super);
    function TdDataTableTemplateDirective(templateRef, viewContainerRef) {
        return _super.call(this, templateRef, viewContainerRef) || this;
    }
    return TdDataTableTemplateDirective;
}(TemplatePortalDirective));
__decorate([
    Input(),
    __metadata("design:type", String)
], TdDataTableTemplateDirective.prototype, "tdDataTableTemplate", void 0);
TdDataTableTemplateDirective = __decorate([
    Directive({ selector: '[tdDataTableTemplate]template' }),
    __metadata("design:paramtypes", [TemplateRef, ViewContainerRef])
], TdDataTableTemplateDirective);
export { TdDataTableTemplateDirective };
//# sourceMappingURL=data-table-template.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/data-table/directives/data-table-template.directive.js
// module id = 54
// module chunks = 3